"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parsePowerSaveMode = void 0;
var parsePowerSaveMode = function (dataView) {
    return {
        autoPowerSaveEnabled: !!dataView.getUint8(0),
        batteryTreshold: dataView.getUint8(1),
        powerLevel: dataView.getUint8(2),
        autoPowerSaving: !!dataView.getUint8(3),
        manualPowerSaveEnabled: !!dataView.getUint8(4)
    };
};
exports.parsePowerSaveMode = parsePowerSaveMode;
